export type CountableComment = {
  isPrivate?: boolean;
  commitUrl?: string | null;
};

export const visibleCommentCount = (
  comments: CountableComment[] | null | undefined,
  canViewPrivateComments: boolean,
  canViewCommitComment: boolean
) =>
  (comments || []).filter(
    comment =>
      (canViewPrivateComments || !comment.isPrivate) &&
      (!comment.commitUrl || canViewCommitComment)
  ).length;
